import React, { useState } from 'react';
import QuestionElementPrompt from 'components/Questions/shared/QuestionElementPrompt.jsx';
import RadioFieldGroup from 'components/shared/RadioFieldGroup';
import RadioField from 'components/shared/RadioFieldGroup/RadioField';
import ReactHtml from 'components/shared/ReactHtml';
import request from 'utils/request_ajax';
import { MultipleChoiceSurveyTypes } from './types';

const MultipleChoiceSurvey = ({ data, meta }) => {
  const [selectedAnswer, setSelectedAnswer] = useState(data?.givenAnswer);

  if (!data) return null;

  const updateAnswer = async value => {
    try {
      setSelectedAnswer(value.target.value);
      await request.postJSON(meta.saveUrl, {
        answer: value.target.value,
        question_id: data.questionId,
      });
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <QuestionElementPrompt
        elementHeaderClass={meta.elementHeaderClass}
        isGradable={data.isGradable}
        isPractice={data.isPractice}
        labelErrorClass={meta.labelErrorClass}
        questionSubjectClass={meta.questionSubjectClass}
        required={data.required}
        subject={data.subject}
      />
      <RadioFieldGroup
        disabled={!!data.disabledText}
        name={`${data.questionType}-${data.questionId}`}
        onChange={updateAnswer}
        selectedValue={selectedAnswer}
      >
        {data.choices?.map((choice, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <RadioField key={index} className="px-16 py-10" value={choice}>
            <ReactHtml component="span">{choice}</ReactHtml>
          </RadioField>
        ))}
      </RadioFieldGroup>
    </>
  );
};

MultipleChoiceSurvey.propTypes = MultipleChoiceSurveyTypes;

export default MultipleChoiceSurvey;
